import { View, Text, StyleSheet } from "@react-pdf/renderer";
import { VotacaoParticipanteResponse } from "core/features/assembleia/typings";
import { useCurrentTenant } from "core/features/auth/tenant.store";
import { PDFLayout } from "ui/components/PDF";
import colors from "core/resources/theme/colors";

interface PDFRelatorioProps {
  votacaoNome: string;
  participantes: VotacaoParticipanteResponse[] | undefined;
}

function PDFRelatorio({ votacaoNome, participantes }: PDFRelatorioProps) {
  const { tenant } = useCurrentTenant();

  const ParticipanteItem = ({
    participante,
  }: {
    participante: VotacaoParticipanteResponse;
  }) => {
    const unidadesString = participante.unidades
      .map((u) =>
        u.blocoQuadra
          ? `${u.numero} / Bloco ${u.blocoQuadra?.replace(/^Bloco/i, "")}`
          : u.numero
      )
      .join(", ");

    const totalPeso = participante.unidades.reduce(
      (acc, u) => acc + (u.peso ?? 0),
      0
    );

    return (
      <View style={styles.participanteItem}>
        <View style={styles.participanteContent}>
          <View style={styles.leftContent}>
            <Text style={styles.nome}>{participante.nome}</Text>
            <Text style={styles.unidades}>
              {`Unidade${
                participante.unidades.length > 1 ? "s" : ""
              }: ${unidadesString}`}
            </Text>
          </View>
          <View style={styles.rightContent}>
            <Text style={styles.peso}>{totalPeso}</Text>
          </View>
        </View>
      </View>
    );
  };

  return (
    <PDFLayout
      fontSize={10}
      orientation="portrait"
      includeDocument={true}
      headerProps={{
        logo: tenant.imagemUrl,
        tenant: tenant.nome,
        title: "Lista de participantes",
        subTitle: votacaoNome,
        topRightAdmLogo: true,
        fixed: true,
      }}
    >
      <View style={styles.container}>
        <View style={styles.header}>
          <View style={styles.headerLeft}>
            <Text style={styles.headerText}>Morador</Text>
          </View>
          <View style={styles.headerRight}>
            <Text style={styles.headerText}>Peso</Text>
          </View>
        </View>
        {participantes?.map((participante) => (
          <ParticipanteItem key={participante.id} participante={participante} />
        ))}
      </View>
    </PDFLayout>
  );
}

const styles = StyleSheet.create({
  container: {
    flexDirection: "column",
    width: "100%",
  },
  header: {
    flexDirection: "row",
    marginBottom: 8,
  },
  headerLeft: {
    flex: 1,
  },
  headerRight: {
    width: 60,
    textAlign: "right",
  },
  headerText: {
    fontSize: 9,
    fontWeight: "bold",
  },
  participanteItem: {
    flexDirection: "column",
    marginBottom: 4,
    paddingBottom: 4,
    borderBottomWidth: 1,
    borderBottomColor: colors.lightGray,
  },
  participanteContent: {
    flexDirection: "row",
  },
  leftContent: {
    flex: 1,
  },
  rightContent: {
    alignItems: "flex-end",
  },
  nome: {
    fontSize: 9,
    marginBottom: 2,
    fontWeight: "medium",
  },
  unidades: {
    fontSize: 7.5,
    color: colors.black700,
  },
  peso: {
    fontSize: 10,
    fontWeight: "medium",
  },
});

export default PDFRelatorio;
